import React from "react";

export function lazyWithRetry(importFn) {
  return React.lazy(() =>
    importFn().catch((error) => {
      const isChunkLoadError =
        error?.message?.includes("Failed to fetch dynamically imported module") ||
        error?.message?.includes("error loading dynamically imported module") ||
        /Loading chunk [\d\w-]+ failed/i.test(error?.message || "");

      const alreadyReloaded = sessionStorage.getItem("chunk-reload");

      if (isChunkLoadError && !alreadyReloaded) {
        sessionStorage.setItem("chunk-reload", "1");
        window.location.reload();
        return new Promise(() => {}); // suspend forever until reload happens
      }

      sessionStorage.removeItem("chunk-reload");
      throw error;
    })
  );
}
